import { infoGlobal } from "./../api/infoGlobal";

const isDebugMode = infoGlobal.GetEnableDebug(); // Recupera el valor desde config.json

// Guardamos una referencia del `console.log` y `console.error` originales
const originalConsoleLog = console.log;
const originalConsoleError = console.error;

// Reescribimos `console.log`
console.log = (...args) => {
  if (isDebugMode) {
    originalConsoleLog(...args);
  }
};

// Reescribimos `console.error`
console.error = (...args) => {
  if (isDebugMode) {
    originalConsoleError(...args);
  }
};
